import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const KeyboardShortcuts = () => {
  const [isOpen, setIsOpen] = useState(false);

  const shortcuts = [
    { key: 'Ctrl + Enter', description: 'Generate prompt' },
    { key: 'Ctrl + C', description: 'Copy prompt to clipboard' },
    { key: 'Ctrl + O', description: 'Optimize current prompt' },
    { key: 'Ctrl + S', description: 'Save to favorites' },
    { key: 'Ctrl + E', description: 'Export prompt' },
    { key: 'Ctrl + Z', description: 'Undo last change' },
    { key: 'Ctrl + Y', description: 'Redo last change' },
    { key: 'Ctrl + K', description: 'Clear form' },
    { key: 'Esc', description: 'Close dialogs' }
  ];

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-20 md:bottom-6 right-4 md:right-6 w-12 h-12 bg-primary text-primary-foreground rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center z-50"
        aria-label="Keyboard shortcuts"
      >
        <Icon name="Keyboard" size={20} />
      </button>
      {isOpen && (
        <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[200] flex items-center justify-center p-4" onClick={() => setIsOpen(false)}>
          <div className="bg-card border border-border rounded-lg shadow-xl max-w-md w-full p-6 space-y-4" onClick={(e) => e?.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-foreground">Keyboard Shortcuts</h3>
              <button
                onClick={() => setIsOpen(false)}
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Close"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <div className="space-y-2 max-h-96 overflow-y-auto custom-scrollbar">
              {shortcuts?.map((shortcut, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-muted rounded-lg">
                  <span className="text-sm text-foreground">{shortcut?.description}</span>
                  <kbd className="px-2 py-1 bg-background border border-border rounded text-xs font-mono text-foreground">
                    {shortcut?.key}
                  </kbd>
                </div>
              ))}
            </div>

            <div className="flex items-start gap-2 p-3 bg-primary/10 rounded-lg">
              <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
              <p className="text-xs text-muted-foreground">
                Use these shortcuts to speed up your workflow and become a power user
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default KeyboardShortcuts;